import { render, staticRenderFns } from "./FiltersList.vue?vue&type=template&id=4d777eb2&scoped=true&functional=true&"
var script = {}
import style0 from "./FiltersList.vue?vue&type=style&index=0&id=4d777eb2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "4d777eb2",
  null
  
)

export default component.exports